import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <main data-testid="page-payment-cancel" className="min-h-screen bg-[#050505] px-6 pt-32 pb-24 flex flex-col items-center text-center">
      <XCircle className="text-white/40" size={48} />
      <h1 className="mt-6 font-display text-5xl uppercase tracking-tight text-white">Checkout cancelled</h1>
      <p className="mt-4 max-w-md text-white/60">No charge was made. You can return to the gallery and try again anytime.</p>
      <div className="mt-10 flex gap-4">
        <Link to="/#books" className="magnetic-btn rounded-full bg-[#7C3AED] px-6 py-3 text-sm uppercase tracking-wider text-white hover:bg-white hover:text-black">Back to Books</Link>
        <Link to="/#art" className="magnetic-btn rounded-full border border-white/30 px-6 py-3 text-sm uppercase tracking-wider text-white hover:bg-white hover:text-black">Back to Art</Link>
      </div>
    </main>
  );
}
